"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Compare = void 0;
var Compare;
exports.Compare = Compare;
(function (Compare) {
  Compare["More"] = ">";
  Compare["Less"] = "<";
  Compare["MoreOrEqual"] = ">=";
  Compare["LessOrEqual"] = "<=";
  Compare["Exist"] = "exist";
  Compare["Contains"] = "in";
})(Compare || (exports.Compare = Compare = {}));